import { ProcessedSecurity } from "../types";

const SECURITY_TYPE_INDEX = 4;
const MATURITY_DATE_INDEX = 3;

const sortSecurities = (data: ProcessedSecurity[]) => {
  const securities = ["m-bono", "udi-bono", "cete", "mex-corp-cebur"];

  const securitiesLists = securities.map((security) => data.filter((item) => item[SECURITY_TYPE_INDEX] === security));

  securitiesLists.forEach((securityList) => {
    securityList.sort((a, b) => {
      return (
        new Date(a[MATURITY_DATE_INDEX] as unknown as string).getTime() -
        new Date(b[MATURITY_DATE_INDEX] as unknown as string).getTime()
      );
    });
  });

  return securitiesLists.flat();
};

export default sortSecurities;
